// @ts-expect-error not migrated to TS yet
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
import ListingLibResolvedCell from 'framework-listing-lib/table/ListingLibResolvedCell';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UserCell({
  crmObject,
  propertyName
}) {
  const userId = getPropertyValue(crmObject, propertyName);
  return /*#__PURE__*/_jsx(ListingLibResolvedCell, {
    id: userId,
    objectType: USER
  });
}